module.exports = __webpack_public_path__ + "img/premium.62821f9e.svg";